import { loadStripe } from '@stripe/stripe-js'

const stripe = loadStripe(
  process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
).then(response => response)

export default stripe
